import { mapActions, mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';

export default {
    created() {
      this.querySalutations();
    },
    computed: {
      ...mapState('Auth', ['allowedSalutations']),
    },
    methods: {
      ...mapActions({
        querySalutations: 'Auth/querySalutations',
      }),
    },
    watch: {
      allowedSalutations(val) {
          if (val) {
              this.$validator.extend('radioTabs', {
                  getMessage: field =>
                      `No value has been selected for ${field}.`,
                  validate: value => {
                      if (val !== '') {
                          return true;
                      } else {
                          return false;
                      }
                  }
              });
          }
      }
  },
};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/titleField.js